define('models/calendar/nutrition/food',[
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/api',
    // parent
    'src/file-upload-model',
    // collections
    'collections/calendar/nutrition/servings'
], function(
    _, Backbone, Mustache, U,
    // services
    API,
    // parent
    FileUploadModel,
    // collections
    CServings
) {

    var MFood = FileUploadModel.extend({
        idAttribute: '_id',
        files: ['photo'],
        urlRoot: API.url("nutrition/food/"),
        defaults: {
            name: "",
        },

        initialize: function(attrs, options) {
            // FIXME this is a fix of the incoherent objects from the API. (FoodFavorite)
            var id = this.get('id');
            if (id) this.setId(id);
            this._initServings();

            this.listenTo(this, {
                'sync': this.onFoodSync,
                'model:reset change:servings': this.onServingUpdate
            });
        },

        getServings: function() {
            var servings = this.servings;
            if (!servings) {
                servings = this.servings = new CServings(this.get('servings'));
            }
            return servings;
        },

        getServing: function(id) {
            var servings = this.getServings();
            if (!servings.isEmpty()) return servings.get(id);
        },

        getDefaultServing: function() {
            var servings = this.getServings();

            /**
             * It could happen that "servings" is an array and as an array the function isEmpty() is not available.
             * The way it works it that if servings is an array, we have to create a new collection, add "servings" to the collection and clone it in "servings"
             */
            if (servings.constructor === Array) {
                var collection = new CServings(this.get('servings'));
                collection.add(servings);
                servings = collection.clone();
            }

            if (!servings.isEmpty()) return servings.at(servings.length > 1 ? 1 : 0);
        },

        /**
         * Replaces the serving array.
         * @param {Array} servings array of serving objects
         * @param {Object} options to pass to set.
         */
        setServings: function(servings, options) {
            return this.set({ servings: servings }, options);
        },

        isFavorite: function() {
            return false;
        },

        isEditable: function() {
            return this.get('_isEditable');
        },

        _resetServings: function() {
            var servings = this.servings;
            if (servings) servings.reset(this.get('servings'));
        },

        _initServings: function() {
            if (this.get('servings')) {
                this.getServings();
            }
        },
        
        setPhotoFile: function(blob) {
            this.set('photo', blob);
        },

        ////////////
        // events //
        ////////////
        onFoodSync: function() {
            this._initServings();
        },

        onServingUpdate: function() {
            this._resetServings();
        }

    });

    return MFood;
});

